import script from "./CategoryListTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryListTemplate.vue?vue&type=script&setup=true&lang=js"

import "./CategoryListTemplate.vue?vue&type=style&index=0&id=8e0dd2ac&lang=scss&scoped=true"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e0dd2ac"]])

export default __exports__